const schema = [
  {
    name: 'address_port',
    displayName: 'Address Port',
    nested: true,
    systemIdField: null,
    displayIdField: null,
    deletable: true,
    fields: [
      {
        name: 'line1',
        displayName: 'Line1',
        // tooltip: "Primary address line for the port's location",
        dataType: 'text',
        systemIdentifier: false,
        required: true,
      },
      {
        name: 'line2',
        displayName: 'Line2',
        // tooltip: 'Additional address line (optional)',
        dataType: 'text',
        required: false,
        systemIdentifier: false,
      },
      {
        name: 'city',
        displayName: 'City',
        // tooltip: 'Provide the city where the port is situated',
        dataType: 'shorttext',
        systemIdentifier: false,
        required: true,
      },
      {
        name: 'state',
        displayName: 'State',
        // tooltip: "State or region of the port's location",
        dataType: 'shorttext',
        systemIdentifier: false,
        required: true,
      },
      {
        name: 'country',
        displayName: 'Country',
        // tooltip: 'Country where the port is located',
        dataType: 'simple-reference',
        referenceEntityType: 'country',
        systemIdentifier: false,
        required: true,
      },
      {
        name: 'post_code',
        displayName: 'Post Code',
        // tooltip: "Postal code for the port's address",
        dataType: 'shorttext',
        systemIdentifier: false,
        required: true,
      },
    ],
  },
];
export default schema;
